import { LETTERS_NUMBERS_UNDERSCORES_REGEXP_LABEL } from 'shared/constants/error-labels';
import { LETTERS_NUMBERS_UNDERSCORES_REGEXP } from 'shared/constants/validation-regex-constants';
import { z } from 'zod';

export const KeySchema = z.object({
  label: z
    .string()
    .min(2, { message: 'Name must be at least 2 characters long.' })
    .max(50, {
      message: 'Name must be no more than 50 characters long.',
    })
    .regex(LETTERS_NUMBERS_UNDERSCORES_REGEXP, {
      message: LETTERS_NUMBERS_UNDERSCORES_REGEXP_LABEL,
    }),
});

export const EditKeySchema = KeySchema;
